import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalContent } from 'components/site/modals/ModalWrapper/ModalContent';
import { useGetModalProperties } from 'components/site/modals/ModalWrapper/ModalContent/useGetModalProperties';
import { motion } from 'framer-motion';
import { EColors, EGrads, EHovers } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

export const ModalWrapperPC = (): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const getModalPropreties = useGetModalProperties();
    const modal = getModalPropreties.getModal();
    const width = modal.widthPC ? modal.widthPC : 800;

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
                style={{
                    zIndex: 1000002,
                    height: 'fit-content'
                }}
            >
                <S_Close
                    onClick={() => {
                        ctxModal.setModal(null);
                    }}
                    $left={(window.innerWidth - width) / 2 + width - 40}
                >
                    <FontAwesomeIcon icon={['fal', 'xmark']} />
                </S_Close>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.2 }}
                style={{
                    zIndex: 1000001,
                    height: 'fit-content'
                }}
            >
                <S_Content $height={window.innerHeight - 150} $width={width}>
                    <ModalContent />
                </S_Content>
            </motion.div>
        </>
    );
};

const S_Content = styled.div<{ $width: number; $height: number }>`
    width: ${(props) => props.$width}px;
    max-height: ${(props) => props.$height}px;
    margin: 75px 0 0 0;
    border-radius: 7px;
    overflow: hidden;
    background-color: white;
    z-index: 1000001;
    display: flex;
`;

const S_Close = styled.div<{ $left: number }>`
    position: absolute;
    top: 18px;
    z-index: 1000001;
    left: ${(props) => props.$left}px;
    color: ${EColors.DARK};
    background: ${EGrads.ACC1_GRAD};
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    font-size: 20px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
        box-shadow: ${EHovers.LIGHT2}, 0px 10px 30px rgba(0, 0, 0, 0.3);
    }
`;
